import { Component, Input, OnInit } from '@angular/core';
import { CustomerDetailsModel } from '../customer-details.model';

@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnInit{
@Input() addressDetails=new CustomerDetailsModel();
@Input() dropdownnData:any
filterStateDropdown :any;
filterDestrictDropdown:any;
constructor(){}

  ngOnInit(): void {
    if (this.addressDetails?.countryId) {
      this.onChangeCountry(this.addressDetails.countryId);
    } else if (this.addressDetails?.country) {
      // Fallback for when only name is present, though we should prefer IDs
      const country = this.dropdownnData?.countryDropdown?.find(x => x.name === this.addressDetails.country);
      if (country) {
        this.onChangeCountry(country.id);
      }
    }

    if (this.addressDetails?.stateId) {
      this.onChangeState(this.addressDetails.stateId);
    } else if (this.addressDetails?.state) {
      const state = this.dropdownnData?.stateDropdown?.find(x => x.name === this.addressDetails.state);
      if (state) {
        this.onChangeState(state.id);
      }
    }

    if (this.addressDetails?.districtId) {
      this.onChangeDistrict(this.addressDetails.districtId);
    } else if (this.addressDetails?.district) {
      const district = this.dropdownnData?.cityDropdown?.find(x => x.name === this.addressDetails.district);
      if (district) {
        this.onChangeDistrict(district.id);
      }
    }
  }

  onChangeCountry(countryId) {
    const country = this.dropdownnData?.countryDropdown?.find(x => x.id === countryId);
    this.addressDetails.country = country?.name;
    this.addressDetails.countryId = countryId;
    this.filterStateDropdown = this.dropdownnData?.stateDropdown?.filter(x => x.extra1 === countryId);
  }

  onChangeState(stateId) {
    const state = this.dropdownnData?.stateDropdown?.find(x => x.id === stateId);
    this.addressDetails.state = state?.name;
    this.addressDetails.stateId = stateId;
    const filterId = state?.extra2 || stateId; // Based on existing logic
    this.filterDestrictDropdown = this.dropdownnData?.cityDropdown?.filter((x) => x.extra1 === filterId);
  }

  onChangeDistrict(districtId) {
    const district = this.dropdownnData?.cityDropdown?.find(x => x.id === districtId);
    this.addressDetails.district = district?.name;
    this.addressDetails.districtId = districtId;
  }
}
